import { useRef } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustSection } from "@/components/site/TrustSection";
import { BankComparison } from "@/components/site/BankComparison";
import { EMICalculator } from "@/components/site/EMICalculator";
import { HowItWorks } from "@/components/site/HowItWorks";
import { QueryForm } from "@/components/site/QueryForm";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const formRef = useRef(null);
  const scrollToForm = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToCompare = () => {
    document.getElementById("compare")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="landing-page">
      <Header onCTA={scrollToForm} />
      <Hero onCompare={scrollToCompare} onQuote={scrollToForm} />
      <TrustSection />
      <BankComparison onApply={scrollToForm} />
      <EMICalculator onQuote={scrollToForm} />
      <HowItWorks />
      <QueryForm ref={formRef} />
      <FAQ />
      <Footer />
    </div>
  );
}
